// extracted by mini-css-extract-plugin
export default {"fullWidth":"gq-z","image":"hq-z","lazyLoadPicture":"iq-z","lazyLoadSpinner":"jq-z","lazyLoadSpin":"kq-z","lazyLoadImage":"lq-z","hasStyledAspectRatio":"mq-z"};